module.exports = __webpack_public_path__ + "img/astronaut.f49f5c13.png";